function Award(){
    return (
        <>
        <div className="flex md:flex-row flex-col md:mx-32 mx-8 my-6">
          <img src="/small-logo.svg" className="md:w-auto w-16" />
          <div className="md:ml-12 md:grid md:grid-cols-3 md:space-y-0 space-y-5 md:mt-0 mt-5">
            <div className="flex flex-row items-center">
              <img src="/award/trip-advisor.png" className="w-18 h-16 md:ml-0 -ml-2" />
              <span className="ml-2">
                TripAdvisor Travelers’ Favourites (for Germany, France and Spain)
              </span>
            </div>
            <div className="flex flex-row items-center">
              <img src="/award/travel.png" className="w-18 h-16 md:ml-0 -ml-2" />
              <span className="ml-2">
                World's Leading Car Rental Company Website
              </span>
            </div>
            <div className="flex flex-row items-center">
              <img src="/award/kayak.png" className="w-18 h-16 md:ml-0 -ml-[0.25rem]" />
              <span className="md:ml-2 ml-4">KAYAK 2020 Best Cleanliness</span>
            </div>
          </div>
        </div>
        </>
    );
}

export default Award;